// @flow
type MobileScrollerToggleActionType = 'MOBILESCROLLER/TOGGLE';

export type ActionType = MobileScrollerToggleActionType;

type MobileScrollerToggleAction = {
    type: MobileScrollerToggleActionType,
    payload: {
        showMobileScroller: boolean
    }
};

export type Action = MobileScrollerToggleAction;

export const MOBILESCROLLER_TOGGLE = 'MOBILESCROLLER/TOGGLE';

const ACTION_CREATORS = {
    toggleMobileScroller(
        showMobileScroller: boolean
    ): MobileScrollerToggleAction {
        return {type: MOBILESCROLLER_TOGGLE, payload: {showMobileScroller}};
    }
};

export default {
    ...ACTION_CREATORS
};
